import React from 'react'
import { Tooltip } from 'antd'
import { QuestionCircleTwoTone } from '@ant-design/icons'
import * as PropTypes from 'prop-types'

import { mainTwoToneColor } from '../../../variables'

/**
 * A form label followed by a help icon carrying a tooltip.
 *
 * Mirrors the existing inline idiom (`<Tooltip className="tooltip-icon">{label} <icon/></Tooltip>`)
 * rather than introducing a new visual pattern. `icon` lets a caller keep the icon its own screen
 * already uses -- MainSettings uses the two-tone icon (the default here), UserForm the outlined one.
 */
const LabelWithHelp = ({ label, tooltip, icon }) => (
  <Tooltip className="tooltip-icon" title={tooltip}>
    {label} {icon ?? <QuestionCircleTwoTone twoToneColor={mainTwoToneColor} className="scaleIfRTL" />}
  </Tooltip>
)

LabelWithHelp.propTypes = {
  label: PropTypes.node.isRequired,
  tooltip: PropTypes.node.isRequired,
  icon: PropTypes.node
}

export default LabelWithHelp
